import { render, staticRenderFns } from "./OnNoneGuidance.vue?vue&type=template&id=321922c2&lang=pug"
import script from "./OnNoneGuidance.vue?vue&type=script&lang=js"
export * from "./OnNoneGuidance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports